import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmpleadosServicio } from '../../../services/empleado.service';

@Component({
  selector: 'app-seleccionar-empleado',
  templateUrl: './seleccionar-empleado.component.html',
  styleUrls: ['./seleccionar-empleado.component.css']
})
export class SeleccionarEmpleadoComponent implements OnInit {
  listaEmpleados: Array<any>;
  loading: boolean;
  @Input() tipoEmpleado;
  @Input() ID_EMPLEADO?;
  @Input() ruta;

  constructor(
    public activeModal: NgbActiveModal,
    private empleadoService: EmpleadosServicio,
  ) { }

  ngOnInit() {
    this.cargarListaEmpleados();
  }

  cargarListaEmpleados() {
    this.loading = true;
    this.empleadoService.empleadosPorRutasAsignadas(this.ruta, this.tipoEmpleado).subscribe(res => {
      this.listaEmpleados = res;
      this.loading = false;
    }, () => this.loading = false);
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/seleccionar-empleado/seleccionar-empleado.component.ts